// features/billing/billingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BillingPlan {
    tenantId: string;
    planCode: string;
    status: string;
    trialEndsAt: string | null;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    limitsJson: string | null;
    usageJson: string | null;
    updatedAt: string;
}

export interface UsageData {
    label: string;
    used: number;
    total: number;
}

interface BillingState {
    plan: BillingPlan | null;
    usageData: UsageData[];
    loading: boolean;
    error: string | null;
}

const initialState: BillingState = {
    plan: null,
    usageData: [
        { label: 'Audience', used: 0, total: 500 },
        { label: 'Campaigns', used: 0, total: 50 },
        { label: 'Automation', used: 0, total: 0 },
        { label: 'Templates', used: 0, total: 0 },
    ],
    loading: false,
    error: null,
};

const billingSlice = createSlice({
    name: 'billing',
    initialState,
    reducers: {
        setBillingPlan: (state, action: PayloadAction<BillingPlan>) => {
            state.plan = action.payload;
            state.loading = false;
            state.error = null;
        },
        setUsageData: (state, action: PayloadAction<UsageData[]>) => {
            state.usageData = action.payload;
        },
        setBillingLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setBillingError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearBilling: (state) => {
            state.plan = null;
            state.loading = false;
            state.error = null;
        },
    },
});

export const { setBillingPlan, setUsageData, setBillingLoading, setBillingError, clearBilling } = billingSlice.actions;
export default billingSlice.reducer;